import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'frodo-confirmation-prompt',
  templateUrl: './confirmation-prompt.component.html',
  styleUrls: ['./confirmation-prompt.component.scss'],
})
export class ConfirmationPromptComponent {
  @Input() title: string;
  @Input() header: string;
  @Input() confirmLabel: string;
  @Input() cancelLabel: string;
  @Input() showHeader = true;
  @Input() isLoading = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  goBack = () => this.back.emit();
}
